import React from "react";
import { useTheme } from "next-themes";
import { Sun, Moon } from "lucide-react";

export default function ThemeToggle({ className = "", testid = "theme-toggle" }) {
  const { resolvedTheme, setTheme } = useTheme();
  const isDark = resolvedTheme === "dark";
  return (
    <button
      type="button"
      onClick={() => setTheme(isDark ? "light" : "dark")}
      title={isDark ? "Switch to light mode" : "Switch to dark mode"}
      aria-label="Toggle dark mode"
      className={`theme-toggle w-9 h-9 rounded-xl inline-flex items-center justify-center shrink-0 ${className}`}
      data-testid={testid}
    >
      {isDark ? <Sun size={17} /> : <Moon size={17} />}
    </button>
  );
}
